import React from 'react';

export default function Footer() {
  return (
    <footer className="py-10 px-6 relative font-sans">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 flex-wrap">
        <div className="font-instrument italic text-white text-xl">
          SANS TITRE
        </div>
        
        <div className="text-white/30 text-xs text-center">
          Sacramento, CA &middot; hello@wearesanstitre.com
        </div>
        
        <div className="text-white/30 text-xs text-center">
          &copy; {new Date().getFullYear()} Sans Titre. All rights reserved.
        </div>
      </div>
    </footer>
  );
}